module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-LEMON-SORB.bc6c3f7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-LEMON-SORB.gif
// module id = pF6X
// module chunks = 0